export enum RubricType {
  blooms = 0,
  passFail = 1,
  decisionMaking = 2,
  evidence = 3,
  peerEngagement = 4,
  criticalThinking = 5,
  demoDelivery = 6,
}

// convenience data types as enums are a nightmare to work dynamically with in JS
export const RubricTypeMap = {
  blooms: RubricType.blooms,
  passFail: RubricType.passFail,
  decisionMaking: RubricType.decisionMaking,
  evidence: RubricType.evidence,
  peerEngagement: RubricType.peerEngagement,
  criticalThinking: RubricType.criticalThinking,
  demoDelivery: RubricType.demoDelivery,
}

export const RubricTypeReverseMap = {
  [RubricType.blooms]: 'blooms',
  [RubricType.passFail]: 'passFail',
  [RubricType.decisionMaking]: 'decisionMaking',
  [RubricType.evidence]: 'evidence',
  [RubricType.peerEngagement]: 'peerEngagement',
  [RubricType.criticalThinking]: 'criticalThinking',
  [RubricType.demoDelivery]: 'demoDelivery',
}

export const RubricTypeList = [
  RubricType.blooms,
  RubricType.passFail,
  RubricType.decisionMaking,
  RubricType.evidence,
  RubricType.peerEngagement,
  RubricType.criticalThinking,
  RubricType.demoDelivery,
]

export const RubricTypeNames = Object.keys(RubricTypeMap)
